import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'
import { TextToSpeech } from '@capacitor-community/text-to-speech'

export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs))
}

export function getTimeBasedRandomString(): string {
	// Get the current timestamp
	const timestamp = Date.now().toString(36) // Convert timestamp to a base-36 string (alphabets and numbers)
	// Generate a random string
	const randomString = Math.random().toString(36).substring(2, 10) // Random string
	// Combine them to create a unique string
	return `${timestamp}-${randomString}`
}

export async function pronounce(text: string, languageCode: string) {
	return TextToSpeech.speak({
		text: text,
		lang: languageCode,
		rate: 1.0,
		pitch: 1.0,
		volume: 1.0,
		category: 'ambient',
	})
}

export function sendToDiscordWebhook(url: string, data: any) {
	fetch(url, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: JSON.stringify({ content: data }),
	}).then()
}
